import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'klassic-recent-emojis'
const MAX_RECENT = 24

export interface RecentEmoji {
  id: string
  native: string
  unified: string
}

export function useRecentEmojis() {
  const [recentEmojis, setRecentEmojis] = useState<RecentEmoji[]>([])

  // Load recent emojis from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored) as RecentEmoji[]
        setRecentEmojis(parsed)
      }
    } catch (error) {
      console.error('Failed to load recent emojis:', error)
    }
  }, [])

  // Add an emoji to recent emojis
  const addRecentEmoji = useCallback((emoji: RecentEmoji) => {
    setRecentEmojis((prev) => {
      // Remove if already exists
      const filtered = prev.filter((e) => e.id !== emoji.id)

      // Add to beginning
      const updated = [emoji, ...filtered].slice(0, MAX_RECENT)

      // Save to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
      } catch (error) {
        console.error('Failed to save recent emojis:', error)
      }

      return updated
    })
  }, [])

  // Clear all recent emojis
  const clearRecentEmojis = useCallback(() => {
    setRecentEmojis([])
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch (error) {
      console.error('Failed to clear recent emojis:', error)
    }
  }, [])

  return {
    recentEmojis,
    addRecentEmoji,
    clearRecentEmojis,
  }
}
